import React from 'react';

import { Icon } from '@rbilabs/components-library/build/components/icon';
import { useIntl } from 'react-intl';
import { Link } from 'react-router';
import styled from 'styled-components';

import { BackArrowLink } from 'components/navigation/back-arrow';
import { useMediaQuery } from 'hooks/use-media-query';
import { routes } from 'utils/routing';

interface IProps {
  url?: string;
  onClick: VoidFunction;
}

const MenuLinkWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin: 24px 0px;
  padding: 24px 48px;
  ${Styles.desktopLarge} {
    padding: 24px 0px;
  }
`;

const Text = styled.span`
  margin: auto;
  font-size: 1.125rem;
`;

export const MainMenuLink: React.FC<IProps> = ({ url, onClick }) => {
  const { formatMessage } = useIntl();
  const isDesktop = useMediaQuery('desktop');

  return isDesktop ? (
    <MenuLinkWrapper>
      <Link to={url || routes.menu} onClick={onClick}>
        <Icon icon="back" color={'icon-default'} width="24px" height="24px" aria-hidden />
      </Link>
      <Text>{formatMessage({ id: 'mainMenu' })}</Text>
    </MenuLinkWrapper>
  ) : (
    <BackArrowLink to={url || routes.menu} />
  );
};
